import React from "react";
import { LoadingDiv } from "./styledLoading";

function Loading() {
  return (
    <LoadingDiv>
      <h1>Loading, please wait...</h1>
    </LoadingDiv>
  );
}

export default Loading;
